import { Trash2, X } from "lucide-react";

import { Button } from "@components/button/button";
import { SpinnerSimple } from "@components/spinner-simple/spinner-simple";

import { useAtualizarUsuarioCliente } from "@/hooks/usuários/atualizar-usuario-do-cliente";

import { useStoreZustandUsuarioCliente } from "@/store-zustand/usuarios-do-clientes";

type IExcludeItem = {
  onCancel: () => void;
};

export function ModalInativarUsuarioDoCliente({ onCancel }: IExcludeItem) {
  const { usuarioClienteSelecionado } = useStoreZustandUsuarioCliente();
  const { atualizarUsuarioClienteAsync, isLoading } = useAtualizarUsuarioCliente();

  const handleInativaUsuarioCliente = async () => {
    await atualizarUsuarioClienteAsync({
      user_id: Number(usuarioClienteSelecionado?.id),
      payload: {
        ativo: usuarioClienteSelecionado?.status !== "ativo",
      },
    });

    onCancel();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="relative w-full max-w-md space-y-5 rounded-lg bg-white p-6 shadow-lg">
        <div className="flex justify-between">
          <h3 className="flex text-left text-lg font-semibold text-gray-800">
            <Trash2 className="mr-2" /> Confirmar inativação?
          </h3>

          {/* Botão de fechar no topo direito */}
          <button
            onClick={onCancel}
            className="absolute right-3 text-gray-500 hover:text-gray-800"
            aria-label="Fechar modal"
          >
            <X size={20} />
          </button>
        </div>
        <p className="text-left text-sm text-gray-600">
          Você tem certeza de que deseja inativar o usuário{" "}
          <strong className="text-orange-500">{usuarioClienteSelecionado?.nome}</strong>
          ?<br />
          Ele não poderá mais acessar o sistema até ser reativado.
        </p>

        <div className="mt-4 flex w-full justify-between gap-4">
          <Button
            disabled={isLoading}
            variant="secondary"
            className="w-full rounded-md bg-gray-200 px-4 py-2 text-gray-700 hover:bg-gray-300"
            onClick={onCancel}
          >
            Cancelar
          </Button>
          <Button
            disabled={isLoading}
            variant="default"
            className={`w-full px-4 py-2 text-white ${
              usuarioClienteSelecionado?.status === "ativo"
                ? "bg-primary text-primary-foreground hover:bg-primary/90"
                : "bg-red-600 hover:bg-red-700"
            }`}
            onClick={handleInativaUsuarioCliente}
          >
            {isLoading ? (
              <SpinnerSimple />
            ) : usuarioClienteSelecionado?.status === "ativo" ? (
              "Inativar usuário"
            ) : (
              "Reativar usuário"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
